import { LocalStorageKey } from "../types"
import { ApiStatus } from "../types/api/status"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { useDispatch, useSelector } from "react-redux"
import { onFetchSalesChannels, selectSaleChannelState, changeStatus, onSetEditSaleChannel, setAction } from "../redux/slices/saleChannelSlice"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { SaleChannelAPI } from "../apis/SaleChannelAPI"
import { SaleChannel } from "../types/slices/saleChannelType"

export const useSaleChannelStore = () => {
    const dispatch = useDispatch()
    const { salesChannels, editSaleChannel, status, action } = useSelector(selectSaleChannelState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getSalesChannels = async (data?:any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SaleChannelAPI.list(idcompany, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(onFetchSalesChannels(detail))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createSaleChannel = async (data:any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SaleChannelAPI.create({...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const updateSaleChannel = async (idchannel:number, data:any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SaleChannelAPI.update(idchannel, {...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteSaleChannel = async (idchannel: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SaleChannelAPI.delete(idchannel)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setEditSaleChannel = (channel:SaleChannel) => {
        try {
            dispatch(onSetEditSaleChannel(channel))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionSaleChannel = (action:string) => {
        try {
            dispatch(setAction(action))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        salesChannels,
        editSaleChannel,
        status,
        action,
        getSalesChannels,
        createSaleChannel,
        updateSaleChannel,
        deleteSaleChannel,
        setEditSaleChannel,
        setActionSaleChannel
    }
}